// extracted by mini-css-extract-plugin
module.exports = {"TooltipDate":"FormatRow_TooltipDate__TF+oH","TooltipIcon":"FormatRow_TooltipIcon__05Euy","TooltipMetrics":"FormatRow_TooltipMetrics__iqs14"};